import { render } from "./TwoFAForm.vue?vue&type=template&id=3efc42dc"
import script from "./TwoFAForm.vue?vue&type=script&lang=js"
export * from "./TwoFAForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__